<template>    
    <v-container fluid fill-height pa-3 class="d-flex flex-grow-1 fill-parent-height">
      <LeftMenu/>             
      <v-layout row wrap>
        <v-flex xs1/>
        <v-flex xs11>
          <v-row
            no-gutters
          >
            <v-col md="3">
              &nbsp;&nbsp;&nbsp;  Country: {{this.customerInfo.country.name}} 
            </v-col>
            <v-col md="4">
               Company: {{this.customerInfo.company}} 
            </v-col>
            <v-col md="2">
              Email: {{this.customerInfo.email}} 
            </v-col>
          </v-row>
          <v-row
            no-gutters
            class="main"
          >
            <v-col md="6" class="pa-2" 
            >
              <v-card
                height="100%"
                class="pa-2"
                outlined
                tile
              >
                <v-layout row wrap>                                         
                  <v-flex xs12 >
                    <CustomerTimeline :current-customer="this.customerInfo"/>
                  </v-flex>                                            
                </v-layout>                                        
              </v-card>
            </v-col>

            <v-col md="6" class="pa-2"
            >
              <v-card
                height="100%"
                class="pa-2"
                outlined
                tile
              >
                <v-layout row wrap class="pa-1">   
                  <v-flex xs12>
                    <Offers inner-page="true" :current-customer="this.customerInfo" customer-id='this.$route.params.id'/>
                  </v-flex>
                </v-layout>                                        
              </v-card>
            </v-col>
          </v-row>
        </v-flex>
      </v-layout>
    </v-container>
</template>


<script>
import LeftMenu from '../components/LeftMenu';
import DatePicker from '../components/DatePicker';
import CustomerTimeline from '../components/CustomerTimeline';
import Offers from '../views/Offers';
import breadcrumbs from '../store/breadcrumbs.js'

const API_URL = 'definitions/';
const CUSTOMERS_API_URL = 'definitions/customers/';
export default {
    components:{
      LeftMenu,
      DatePicker,
      CustomerTimeline,
      Offers
    },
    data () {
      return {
        customerInfo: {country : {name:''}}
      }
    },
    computed: {      
      headersSummary () {
        return [
          { text: 'Period', align: 'center', sortable: true, value: 'periodText' },                
          { text: 'Balance', align: 'right', value: 'balanceFormatted' },
          { text: 'Currency', value: 'currency.code' },
          { text: 'Transactions', align: 'right', sortable: true, value: 'paymentsFormatted' },
          { text: 'Earnings',  align: 'right',value: 'earningsFormatted'  },  
        ]
      },      
      
    },
    created() {    
      this.getCustomerInfo();      
    },
    watch: {      
      dialogManual (val) {
        val || this.closeManual()
      },
    },
    methods: {        
      getCustomerInfo(){     
        this.$axios.get(this.$apiurl + CUSTOMERS_API_URL+this.$route.params.id)
            .then(response => {
                this.customerInfo = response.data;
                breadcrumbs.dispatch('setBreadCrumps', [
                                        { text: 'Customers', disabled: false, href: '/#/customers'},
                                        { text: this.customerInfo.customerName, disabled: true, } // placeholder
                                    ]);
                breadcrumbs.dispatch('setCustomer', this.customerInfo);
            }) 
            .catch(error => {
                console.log(error);
            });                         
      },
    }
}
</script>
<style scoped>
.summaryItem{
  background-color: grey;
   width: 100%;
  height: 100%; 
  align-content: center
}
.main{
  width: 100%;
  height: 100%;  
}

</style>
